import React from 'react'
import styled from 'styled-components'
import { display } from 'styled-system'

type AlertType = 'success' | 'warning' | 'error'

interface AlertProps {
  title?: string | React.ReactNode
  message: string | React.ReactNode
  btnName?: string
  type: AlertType
  onClose: () => void
}

const DimBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`

// const AlertWrapper = styled.div`
//   position: fixed;
//   // position: relative;
//   // position: absolute;
//   top: 30%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   background-color: white;
//   width: 400px;
//   min-height: 72px;
//   max-height: 450px;
//   border-radius: 16px;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//   z-index: 1000;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start; /* 수평은 왼쪽 정렬 유지 */
//   justify-content: center; /* 세로로 중앙 정렬 */
//   padding: 32px;
//   // overflow: hidden;
// `

const AlertWrapper = styled.div`
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  width: 400px;
  max-width: 90vw; /* 모바일에서 양옆 여백 생기게 */
  min-height: 72px;
  max-height: 450px;
  border-radius: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 32px;

  @media (max-width: 480px) {
    width: 90vw; /* 모바일 화면에서는 전체 너비의 90%로 */
    padding: 24px; /* 패딩도 줄이기 */
  }
`

// const IconWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin: 10px auto;
// `

const Title = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: flex-start; /* 수평은 왼쪽 정렬 유지 */
  justify-content: center; /* 세로로 중앙 정렬 */
  white-space: pre-wrap !important;
`

// const Separator = styled.div`
//   width: 100%;
//   height: 1px;
//   background-color: #ccc;
//   margin: 10px 0;
// `

const MessageWrapper = styled.div`
  flex-grow: 1;
  font-size: 16px;
  overflow: auto; // 스크롤 가능하도록
  max-height: 300px; // 최대 높이 설정
  padding-bottom: 10px; // 여백 추가
`

const Message = styled.div`
  font-size: 14px;
  color: #666;
  flex-grow: 1;
  overflow-y: auto;
  white-space: pre-wrap;
  text-align: center;
  padding: 10px;
`

// const CloseButton = styled.button`
//   border: none;
//   border-radius: 4px;
//   padding: 10px 20px;
//   margin-left: auto; /* 오른쪽 정렬 */
//   cursor: pointer;
// `

const CloseButton = styled.div`
  position: absolute;
  top: 16px; /* 상단에 위치 */
  right: 16px; /* 오른쪽에 위치 */
  cursor: pointer;
`

// ✅ SVG 아이콘 추가
const renderIcon = (type: AlertType) => {
  switch (type) {
    case 'success':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#28a745"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="50"
          height="50"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#28a745"
            strokeWidth="3"
            fill="none"
          />
          <path d="M16 8L10 14L7 11" stroke="#28a745" strokeWidth="3" />
        </svg>
      )
    case 'warning':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ffc107"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="50"
          height="50"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#ffc107"
            strokeWidth="3"
            fill="none"
          />
          <line
            x1="12"
            y1="8"
            x2="12"
            y2="14"
            stroke="#ffc107"
            strokeWidth="3"
          />
          <circle cx="12" cy="17" r="1.5" fill="#ffc107" />
        </svg>
      )
    case 'error':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#dc3545"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="50"
          height="50"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#dc3545"
            strokeWidth="3"
            fill="none"
          />
          <line
            x1="8"
            y1="8"
            x2="16"
            y2="16"
            stroke="#dc3545"
            strokeWidth="3"
          />
          <line
            x1="8"
            y1="16"
            x2="16"
            y2="8"
            stroke="#dc3545"
            strokeWidth="3"
          />
        </svg>
      )
    default:
      return null
  }
}

const Alert: React.FC<AlertProps> = ({
  type,
  title,
  message,
  btnName,
  onClose,
}) => {
  return (
    <>
      <DimBackground />
      <AlertWrapper>
        <CloseButton onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="30px"
            height="30px"
          >
            <path d="M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 30.486328 15.978516 A 1.50015 1.50015 0 0 0 29.439453 16.439453 L 24 21.878906 L 18.560547 16.439453 A 1.50015 1.50015 0 0 0 17.484375 15.984375 A 1.50015 1.50015 0 0 0 16.439453 18.560547 L 21.878906 24 L 16.439453 29.439453 A 1.50015 1.50015 0 1 0 18.560547 31.560547 L 24 26.121094 L 29.439453 31.560547 A 1.50015 1.50015 0 1 0 31.560547 29.439453 L 26.121094 24 L 31.560547 18.560547 A 1.50015 1.50015 0 0 0 30.486328 15.978516 z" />
          </svg>
        </CloseButton>
        {title && <Title>{title}</Title>}
        {message && <MessageWrapper>{message}</MessageWrapper>}
      </AlertWrapper>
    </>
  )
}

export default Alert
